/**
 * Returns the Solana Explorer cluster query param for non-production environments.
 * On prod, returns empty string (mainnet – no param needed).
 */
export function getSolanaClusterParam(): string {
  return import.meta.env.PUBLIC_APP_ENV === 'prod' ? '' : '?cluster=devnet';
}
